import React, { useEffect, useRef, useState } from "react";
import "../../../assets/css/cms/ContactUserPush.css";
import { Container, Row } from "react-bootstrap";
import { BsFillInfoCircleFill } from "react-icons/bs";
import {
  getContactUser,
  postContactUserPush,
  postSendToNetCore,
  getSendToNetcore,
} from "../../../../store/actions/premium/contactUser/contactUser";
import { useDispatch, useSelector } from "react-redux";
import NetcorePopup from "./netcorePopup";
import { clearPostContactUserPushSuccess } from "../../../../store/slices/contactPushUser";
import {
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
} from "@mui/material";
import Loading from "../../../components/utils/loader";
import { Alert } from "@mui/material";
import { breadcrumb } from "./selectStylesNetcore";

const ContactUserPush = () => {
  const dispatch = useDispatch();
  const {
    contactUserListData,
    contactUserListLoading,
    contactUserListError,
    contactUserPushLoading,
    contactUserPushData,
    contactUserPushError,
    sendToNetcoreData,
  } = useSelector((state) => state.contactUser);

  const [contactUserImage, setContactUserImage] = useState();
  const [purpose, setPurpose] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dataUpload, setDataUpload] = useState(false);
  const [page, pageChange] = useState(0);
  const [rowPerPage, rowPerPageChange] = useState(10);
  const [netcoreId, setNetcoreId] = useState();
  const [showAlert, setShowAlert] = useState(false);
  const ref = useRef();
  useEffect(() => {
    dispatch(getContactUser());
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setShowAlert(false);
      dispatch(clearPostContactUserPushSuccess());
    }, 5000);
  }, [showAlert]);

  useEffect(() => {
    dispatch(getContactUser());
  }, [contactUserPushData]);

  useEffect(() => {
    let netCoreParams = {};
    netCoreParams.id = netcoreId;
    dispatch(getSendToNetcore(netCoreParams));
  }, [sendToNetcoreData]);

  // const onImageChange = (e) => {
  //   setContactUserImage(e.target.files[0]);
  //   const formData = new FormData();
  //   formData.append("csvFile", e.target.files[0]);
  //   const config = {
  //     headers: {
  //       "content-type": "multipart/form-data",
  //     },
  //   };
  // };

  const handleSubmit = (e) => {
    e.preventDefault();
    var formdata = new FormData();
    formdata.append("csv_file", contactUserImage);
    formdata.append("purpose", purpose);
    dispatch(postContactUserPush(formdata));
    setDataUpload(true);
    setPurpose("");
    setContactUserImage("");
    ref.current.value = "";
  };

  const handlePageChange = (e, newPage) => {
    pageChange(newPage);
  };

  const handleRowsPageChange = (event) => {
    rowPerPageChange(+event.target.value);
    pageChange(0);
  };

  return (
    <div>
      {isModalOpen && (
        <NetcorePopup
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          netcoreId={netcoreId}
        />
      )}
      <div className={"notification_popup"}>
        {(contactUserPushError || contactUserPushData) && (
          <Alert
            severity={
              contactUserPushError || contactUserPushData?.error == true
                ? `error`
                : `success`
            }
          >
            {" "}
            {contactUserPushError || contactUserPushData?.message}
          </Alert>
        )}
      </div>
      <Container fluid>
        <Row>
          <div className="user_contact_header">
            <h5>User Contact Push</h5>
          </div>
        </Row>
        <Row>
          <div className="breadcrumb_block">
            <ul>
              {breadcrumb?.map((obj, index) => (
                <li>
                  <a href={obj.url}>{obj.label}</a>
                </li>
              ))}
            </ul>
          </div>
        </Row>
        <Row>
          <div className="file_uploading_block">
            <h5>Upload File containing UIDs</h5>
            <form
              encType="multipart/form-data"
              onSubmit={(e) => handleSubmit(e)}
            >
              <input
                type="file"
                accept=".csv"
                required
                ref={ref}
                onChange={(e) => setContactUserImage(e.target.files[0])}
              />
              <input
                type="text"
                placeholder="Enter Purpose..."
                value={purpose}
                required
                onChange={(e) => setPurpose(e.target.value)}
              />
              <button
                className={`${
                  contactUserImage && purpose
                    ? "upload_btn"
                    : "pe-none opacity-50"
                }`}
                type="submit"
                onClick={() => setShowAlert(true)}
              >
                Upload
              </button>
            </form>
          </div>
        </Row>
        <Row>
          {contactUserListLoading ? (
            <div>
              <Loading />
            </div>
          ) : (
            <Paper sx={{ width: "100%" }}>
              <TableContainer>
                <Table style={{ border: "1px solid #BCBCBC" }}>
                  <TableHead>
                    <TableRow
                      style={{ backgroundColor: "#1F2E67", color: "white" }}
                    >
                      <TableCell
                        style={{
                          color: "white",
                          textAlign: "center",
                          border: "1px solid #BCBCBC",
                          maxWidth: "50px",
                        }}
                      >
                        File ID
                      </TableCell>
                      <TableCell
                        style={{
                          color: "white",
                          textAlign: "center",
                          border: "1px solid #BCBCBC",
                        }}
                      >
                        File Name
                      </TableCell>
                      <TableCell
                        style={{
                          color: "white",
                          textAlign: "center",
                          border: "1px solid #BCBCBC",
                          maxWidth: "100px",
                        }}
                      >
                        File Upload Date
                      </TableCell>
                      <TableCell
                        style={{
                          color: "white",
                          textAlign: "center",
                          border: "1px solid #BCBCBC",
                          maxWidth: "100px",
                        }}
                      >
                        Eligible Contacts
                      </TableCell>
                      <TableCell
                        style={{
                          color: "white",
                          textAlign: "center",
                          border: "1px solid #BCBCBC",
                          maxWidth: "100px",
                        }}
                      >
                        Send to
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  {contactUserListData
                    ?.slice(page * rowPerPage, page * rowPerPage + rowPerPage)
                    ?.map((obj, index) => (
                      <TableBody>
                        <TableRow key={index}>
                          <TableCell
                            style={{
                              textAlign: "center",
                              border: "1px solid #BCBCBC",
                              maxWidth: "100px",
                            }}
                          >
                            {obj?.file_id}
                          </TableCell>
                          <TableCell
                            style={{
                              textAlign: "center",
                              border: "1px solid #BCBCBC",
                            }}
                          >
                            <div className="file_name_detail">
                              <div>{obj?.file_name} </div>
                              <div className="info_detail">
                                <span className="info_icon">
                                  <BsFillInfoCircleFill
                                    size={20}
                                    style={{ color: "#473598" }}
                                  />{" "}
                                  <span className="user_info">
                                    {obj?.purpose}
                                  </span>
                                </span>
                              </div>
                            </div>
                          </TableCell>
                          <TableCell
                            style={{
                              textAlign: "center",
                              border: "1px solid #BCBCBC",
                              maxWidth: "100px",
                            }}
                          >
                            {obj?.upload_date}
                          </TableCell>
                          <TableCell
                            style={{
                              textAlign: "center",
                              border: "1px solid #BCBCBC",
                              maxWidth: "100px",
                            }}
                          >
                            {obj?.eligible_contacts}
                          </TableCell>
                          <TableCell
                            style={{
                              textAlign: "center",
                              border: "1px solid #BCBCBC",
                              maxWidth: "300px",
                            }}
                          >
                            <div className="netcore_route_btns">
                              <button
                                className={`${
                                  obj?.status == "0"
                                    ? "netcore_btn pe-none opacity-50"
                                    : "netcore_btn"
                                }`}
                                onClick={() => {
                                  setIsModalOpen(true);
                                  setNetcoreId(obj?.id);
                                }}
                              >
                                Netcore
                              </button>
                              {/* <button className="route_mobile_btn">
                                RouteMobile
                              </button> */}
                            </div>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    ))}
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                page={page}
                rowsPerPage={rowPerPage}
                count={contactUserListData?.length}
                component={"div"}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPageChange}
              ></TablePagination>
            </Paper>
          )}
        </Row>
      </Container>
    </div>
  );
};

export default ContactUserPush;

{
  /* <Row className="user_contact_block">
          {contactUserListLoading ? (
            <div>fetching data.....</div>
          ) : (
            <div className="user_contact_table">
              <table>
                <tr>
                  <th>File ID</th>
                  <th>File Name</th>
                  <th>File Upload Date</th>
                  <th>Eligible Contacts</th>
                  <th>Send to</th>
                </tr>
                {contactUserListData?.map((obj, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>
                      <div className="file_name_detail">
                        <div>{obj?.file_name} </div>
                        <div className="info_detail">
                          <span className="info_icon">
                            <BsFillInfoCircleFill
                              size={20}
                              style={{ color: "#473598" }}
                            />{" "}
                            <span className="user_info">{obj?.purpose}</span>
                          </span>
                        </div>
                      </div>
                    </td>
                    <td>{obj?.upload_date}</td>
                    <td>{obj?.eligible_contacts}</td>
                    <td>
                      <div className="netcore_route_btns">
                        <button
                          className="netcore_btn"
                          onClick={() => setIsModalOpen(true)}
                        >
                          Netcore
                        </button>
                        <button className="route_mobile_btn">
                          RouteMobile
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </table>
            </div>
          )}
        </Row>
        <Row>
          <div>
            <Pagination />
          </div>
        </Row> */
}